import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import {WorkerSchedeClinicheModalComponent} from './worker-schede-cliniche-modal';

export const WorkerSchedeClinicheModalModule: string = ng
    .module('worker-schede_cliniche-modal', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('workerSchedeClinicheModalComponent', WorkerSchedeClinicheModalComponent)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/component/worker-schede-cliniche-modal/worker-schede-cliniche-modal.module.ts